/** Shared vocabulary (statuses, actions, errors). Feature texts live in their own namespace files. */
export default {
  appName: 'Ménage Éclat',
  actions: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    confirm: 'Confirmer',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    create: 'Créer',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    view: 'Voir',
    manage: 'Gérer',
    message: 'Message',
    search: 'Rechercher',
    filter: 'Filtrer',
    retry: 'Réessayer',
    logout: 'Se déconnecter',
    login: 'Se connecter',
    register: 'Créer un compte',
    seeAll: 'Tout voir',
    loadMore: 'Afficher plus',
    today: 'Aujourd’hui',
    directions: 'Itinéraire',
    openDirections: 'Ouvrir l’itinéraire',
    send: 'Envoyer',
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    copy: 'Copier',
  },
  labels: {
    loading: 'Chargement…',
    optional: 'facultatif',
    yes: 'Oui',
    no: 'Non',
    none: 'Aucun',
    all: 'Tous',
    total: 'Total',
    date: 'Date',
    time: 'Heure',
    status: 'Statut',
    address: 'Adresse',
    client: 'Client',
    employee: 'Employé',
    team: 'Équipe',
    sector: 'Secteur',
    duration: 'Durée',
    price: 'Prix',
    notes: 'Notes',
    phone: 'Téléphone',
    email: 'Courriel',
    language: 'Langue',
    amount: 'Montant',
    minutes: '{{count}} min',
    page: 'Page {{page}} sur {{pages}}',
    results: '{{count}} résultat(s)',
    perVisit: 'par visite',
    notifications: 'Notifications',
    noNotifications: 'Aucune notification.',
    markAllRead: 'Tout marquer comme lu',
    devSwitcher: 'DEV : changer de rôle',
    devSwitcherHint: 'Visible uniquement en développement.',
    more: 'Plus',
  },
  roles: { OWNER: 'Propriétaire', ADMIN: 'Administrateur', SUPERVISOR: 'Superviseur', EMPLOYEE: 'Employé', CLIENT: 'Client' },
  jobStatus: {
    DRAFT: 'Brouillon',
    UNASSIGNED: 'À assigner',
    ASSIGNED: 'Assigné',
    CONFIRMED: 'Confirmé',
    EN_ROUTE: 'En route',
    ARRIVED: 'Arrivé',
    IN_PROGRESS: 'En cours',
    COMPLETED: 'Terminé',
    REVIEW_REQUIRED: 'À vérifier',
    CANCELLED: 'Annulé',
    NO_SHOW: 'Absence',
  },
  quoteStatus: {
    DRAFT: 'Brouillon',
    SUBMITTED: 'Reçue',
    UNDER_REVIEW: 'En analyse',
    PRICE_PROPOSED: 'Prix proposé',
    SENT_TO_CLIENT: 'Envoyée',
    ACCEPTED: 'Acceptée',
    REJECTED: 'Refusée',
    EXPIRED: 'Expirée',
    CANCELLED: 'Annulée',
  },
  quoteStatusClient: {
    SUBMITTED: 'En préparation',
    UNDER_REVIEW: 'En préparation',
    PRICE_PROPOSED: 'En préparation',
    SENT_TO_CLIENT: 'Prix disponible',
  },
  paymentStatus: {
    PENDING: 'À payer',
    AUTHORIZED: 'Autorisé',
    PAID: 'Payé',
    FAILED: 'Échoué',
    REFUNDED: 'Remboursé',
    PARTIALLY_REFUNDED: 'Remboursé en partie',
    CANCELLED: 'Annulé',
  },
  payrollStatus: { PENDING: 'En attente', APPROVED: 'Approuvé', PAID: 'Payé', VOID: 'Annulé' },
  conversationStatus: {
    OPEN: 'Ouverte',
    WAITING_CLIENT: 'En attente de réponse',
    WAITING_INTERNAL: 'En attente (interne)',
    RESOLVED: 'Résolue',
    ARCHIVED: 'Archivée',
  },
  agreementStatus: { ACTIVE: 'Actif', PAUSED: 'En pause', CANCELLED: 'Annulé', ENDED: 'Terminé' },
  frequency: {
    ONE_TIME: 'Une seule fois',
    WEEKLY: 'Chaque semaine',
    BIWEEKLY: 'Aux deux semaines',
    MONTHLY: 'Chaque mois',
    CUSTOM: 'Personnalisée',
  },
  contractTerm: { NONE: 'Sans contrat', '6_MONTH': 'Contrat 6 mois', '12_MONTH': 'Contrat 12 mois' },
  billing: {
    ONE_TIME: 'Paiement à chaque visite',
    RECURRING_MONTHLY: 'Mensuel',
    CONTRACT_6_MONTH: 'Contrat 6 mois',
    CONTRACT_12_MONTH: 'Contrat 12 mois',
  },
  propertyType: { HOUSE: 'Maison', CONDO: 'Condo', APARTMENT: 'Appartement', COMMERCIAL: 'Commercial', OTHER: 'Autre' },
  section: { KITCHEN: 'Cuisine', BATHROOM: 'Salle de bain', BEDROOMS: 'Chambres', LIVING: 'Salon', COMMON: 'Espaces communs', OTHER: 'Autres' },
  priority: { LOW: 'Basse', NORMAL: 'Normale', HIGH: 'Haute', URGENT: 'Urgente' },
  compensation: { FIXED_PER_JOB: 'Montant fixe par ménage', HOURLY: 'Taux horaire', PERCENTAGE: 'Pourcentage du prix', CUSTOM: 'Personnalisé' },
  accessKind: { DOOR_CODE: 'Code de porte', KEY: 'Clé', ALARM: 'Alarme', LOCKBOX: 'Boîte à clé', CONCIERGE: 'Concierge', OTHER: 'Autre' },
  weekday: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
  weekdayShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
  errors: {
    generic: 'Impossible d’enregistrer la modification. Réessayez dans quelques secondes.',
    load: 'Impossible de charger ces informations. Réessayez dans quelques secondes.',
    NETWORK: 'Connexion impossible. Vérifiez votre réseau et réessayez.',
    UNAUTHORIZED: 'Votre session a expiré. Reconnectez-vous.',
    INVALID_CREDENTIALS: 'Courriel ou mot de passe invalide.',
    ACCOUNT_DISABLED: 'Ce compte est désactivé.',
    EMAIL_TAKEN: 'Un compte existe déjà avec ce courriel.',
    FORBIDDEN: 'Vous n’avez pas accès à cette action.',
    MISSING_PERMISSION: 'Vous n’avez pas la permission requise pour cette action.',
    NOT_FOUND: 'Élément introuvable.',
    VALIDATION_ERROR: 'Certaines informations sont invalides. Vérifiez le formulaire.',
    RATE_LIMITED: 'Trop de tentatives. Patientez une minute.',
    CUTOFF_PASSED: 'Le délai de modification est dépassé. Écrivez-nous pour toute demande.',
    CHECKLIST_INCOMPLETE: 'Certaines tâches obligatoires ne sont pas cochées.',
    INVALID_TRANSITION: 'Cette étape n’est pas possible pour le moment.',
    ASSIGNMENT_CONFLICT: 'Cette assignation crée un conflit.',
    OVERRIDE_REASON_REQUIRED: 'Indiquez la raison de la dérogation.',
    JOB_NOT_MODIFIABLE: 'Ce ménage ne peut plus être modifié.',
    DATE_IN_PAST: 'Choisissez une date future.',
    ALREADY_PAID: 'Ce paiement est déjà réglé.',
    PAYROLL_INVALID_STATUS: 'Certaines lignes ne peuvent pas passer à ce statut.',
    QUOTE_NOT_EDITABLE: 'Cette soumission ne peut plus être modifiée.',
    CANNOT_GRANT_UNHELD: 'Vous ne pouvez pas accorder une permission que vous n’avez pas.',
    OWNER_PROTECTED: 'Seul un propriétaire peut modifier ce compte.',
    SECTOR_IN_USE: 'Ce secteur contient encore des propriétés.',
    JOB_NOT_STARTED: 'Commencez le ménage avant de cocher les tâches.',
    ACCESS_INFO_RESTRICTED: 'Les informations d’accès sont visibles 24 h avant le ménage.',
    AGREEMENT_NOT_ACTIVE: "Ce service n’est pas actif.",
    AGREEMENT_NOT_PAUSED: "Ce service n’est pas en pause.",
    AGREEMENT_CLOSED: "Ce service est déjà terminé ou annulé.",
    AGREEMENT_BILLED_PER_VISIT: "Ce service est payé à chaque visite.",
    JOB_CANCELLED: "Ce ménage est annulé.",
    CONFIRM_EMAIL: "Compte créé. Confirmez votre courriel avec le lien reçu, puis connectez-vous.",
    STAFF_ONLY_ACTION: "Cette action doit être faite par l’équipe.",
    INVALID_AVAILABILITY: "Une plage de disponibilité est invalide (fin avant le début).",
    LEADER_NOT_MEMBER: "Le chef d’équipe doit faire partie de l’équipe.",
    NOT_REFUNDABLE: "Ce paiement ne peut pas être remboursé.",
    CANNOT_EDIT_SELF: "Vous ne pouvez pas modifier votre propre compte ici.",
    OWNER_ONLY: "Action réservée au propriétaire.",
    ROLE_NOT_EDITABLE: "Ce rôle ne peut pas être modifié.",
    INVALID_RANGE: "La date de fin doit suivre la date de début.",
    SERVICE_TYPE_NOT_FOUND: "Type de service introuvable.",
    PRICE_CHANGE_NOT_ALLOWED: "Vous ne pouvez pas modifier un prix.",
    JOB_NOT_ASSIGNABLE: "Ce ménage ne peut plus être assigné.",
    EMPLOYEE_ONLY: "Action réservée aux employés.",
    NOT_YOUR_PROPERTY: "Cette propriété n’est pas à vous.",
  },
  empty: {
    generic: 'Rien à afficher pour le moment.',
  },
};
